// angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

//svg-icon imports
import { provideSvgIcons } from '@ngneat/svg-icon';

// local imports
import { CatalogIcons } from './catalog-icons';
import { CatalogCommonComponents } from './components';
import { AppCommonModule } from '@app/app-common';
import { SharedModule } from '@app/shared'





@NgModule({
  declarations: [
    ...CatalogCommonComponents
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppCommonModule,
    SharedModule
  ],
  exports: [
    ...CatalogCommonComponents
  ],
  providers: [provideSvgIcons([...CatalogIcons])],
})
export class CatalogCommonModule {
 }
